// extracted by mini-css-extract-plugin
module.exports = {"spinner":"LoadingSpinner_spinner__3vVEP","spinnerImage":"LoadingSpinner_spinnerImage__3dr2q"};